import { FileModel, PartnerProductModel } from '.';
import { unescape } from 'html-escaper';
import { translate } from '../helpers/frontend';
import { SYSTEM_LANGUAGES } from '../actions/variables';

/*
  Partner Product Section Model (Product Promotion Section)
  
  status :
    0 = Inactive
    1 = Active
*/

export class CmsPartnerProductSectionModel {
  constructor(data={}) {
    this._id = data?._id || null;

    this.type = data.type? unescape(data.type): 'C2U';
    
    this.title = data.title? unescape(data.title): null;
    this.description = data.description? unescape(data.description): null;
    
    this.banner = new FileModel(data.banner? data.banner: {});
    this.headerImage = new FileModel(data.headerImage? data.headerImage: {});
    this.url = data.url? data.url: null;
    
    this.products = data.products && data.products.length
      ? data.products.map(d => new PartnerProductModel(d)): [];
    
    this.order = data.order? Number(data.order): 1;
    this.status = data.status? Number(data.status): 0;

    // Localization
    this.localization(data);
  }
  
  localization(data){
    let self = this;
    self.localizedKeys = [ 'title', 'description' ];
    SYSTEM_LANGUAGES.forEach(lang => {
      self.localizedKeys.forEach(k => {
        let key = `${k}${lang}`;
        self[key] = data[key]? unescape(data[key]): data[k];
      });
    });
  }

  isValid() { 
    return this._id? true: false; 
  }

  displayStatus(langObj={}) {
    if(this.isValid()){
      if(this.status === 1) return (<span className="ss-tag bg-success">{translate('Active', langObj)}</span>);
      return (<span className="ss-tag bg-warning">{translate('Inactive', langObj)}</span>);
    }
    return (<></>);
  }
}